// Framework and third-party non-ui
import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

// Hooks, context, and constants
import MapContextProvider from 'contexts/MapContext';
import { UserContext } from 'contexts/UserContext';
import Routes from 'constants/routes';
import { initialize } from 'data/oauth';

// App pages & components
import SplashPage from 'pages/SplashPage';
import HomePage from 'pages/HomePage';
import MapPage from 'pages/MapPage';
import { SearchContext } from 'contexts/SearchContext';

// Third-party components (buttons, icons, etc.)

const App = () => {
  const { setOauthInfo, setUserInfo } = useContext(UserContext);
  const history = useHistory();
  const { searchTerm } = useContext(SearchContext).state;

  useEffect(() => {
    if (localStorage.getItem('userConditionAgreed') === 'true') {
      history.push('/home');
    }
  }, []);

  // everytime app is rendered, call this hook
  useEffect(() => {
    const initAuth = async () => {
      try {
        const oauthInfo = await initialize('Qu2ICECo3cOkjfTQ', 'https://odnr-hub.maps.arcgis.com');

        // Add oauthInfo to UserContext
        setOauthInfo(oauthInfo);
        setUserInfo(undefined);
      } catch (error) {
        // User is not logged in, set userInfo to undefined
        setUserInfo(undefined);
      }
    };
    initAuth();
  }, [setOauthInfo, setUserInfo]);

  return (
    <>
      <Switch>
        <Route path={Routes.Map}>
          <MapContextProvider searchTerm={searchTerm}>
            <HomePage />
            <MapPage />
          </MapContextProvider>
        </Route>

        {localStorage.getItem('userConditionAgreed') !== 'true' && (
          <Route path='*'>
            <SplashPage />
          </Route>
        )}
      </Switch>
    </>
  );
};

export default App;
